import * as React from "react";
import type { SplitButtonSize, SplitButtonVariant } from "./split-button-types";

export interface SplitButtonContextValue {
	size?: SplitButtonSize;
	variant?: SplitButtonVariant;
}

export const SplitButtonContext =
	React.createContext<SplitButtonContextValue | null>(null);

export function useSplitButtonContext() {
	return React.useContext(SplitButtonContext);
}
